import { ActiveChannelRequest } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getOfferActiveChannels = async (offerId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offers/${offerId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetActiveChannels = ({ offerId = '', enabled }: { offerId?: string; enabled: boolean }) => {
  return useGenericQuery<ActiveChannelRequest, RequestError>(
    ['offer-channels-by-id', offerId],
    () => getOfferActiveChannels(offerId),
    {
      enabled,
    }
  );
};
